export const MOBILE_BREAKPOINT_CAROUSEL = 769
export const MOBILE_BREAKPOINT = 860
export const LAPTOP_BREAKPOINT = 1200
export const MOBILE_XS_BREAKPOINT = 480
export const CASPER_TIGERS_CONTRACT_PACKAGE_LINK =
  "https://cspr.live/contract-package/235c4c4a5d3eb22c1d854cf7d4f48b7386fcf95847a2a92a1056fa5591d7f76d"